<template>
  <page-tab
    :banner="banner"
    :breadcrumb="breadcrumb"
    :tabList="tabList"
    listKey="code"
    v-model="tabCurrent"
    @change="tabChange"
  >
    <div class="news-list">
      <div
        class="item"
        v-for="(item, i) in list"
        :key="i"
        @click="toDetail(item.id)"
      >
        <img class="image" :src="item.icon" />
        <div class="item-content">
          <div class="name">{{ item.title }}</div>
          <div class="time">
            {{ item.updateTime && item.updateTime.split(" ")[0] }}
          </div>
          <p>{{ item.summary }}</p>
        </div>
        <div class="btn">
          <em>MORE</em>
          <svg width="14" height="8">
            <line
              x1="0"
              y1="4"
              x2="14"
              y2="4"
              style="fill: none; stroke: #3881f8; stroke-width: 1"
            />
            <polyline
              points="9,0 14,4 9,8"
              style="fill: none; stroke: #3881f8; stroke-width: 1"
            />
          </svg>
        </div>
      </div>
    </div>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
    <el-empty description="暂无数据" v-show="total < 1"></el-empty>
  </page-tab>
</template>
<script>
import PageTab from "@/components/PageTab.vue";
import banner from "@/assets/images/banner/news.png";
import { pageByCode } from "@/api/index";

export default {
  name: "News",
  components: {
    PageTab,
  },
  data() {
    return {
      banner,
      breadcrumb: [
        { name: "首页", path: "/" },
        { name: "企业动态", path: "" },
        { name: "新闻资讯", path: "" },
      ],
      tabList: [
        { name: "新闻资讯", code: "c_news" },
        { name: "行业新闻", code: "c_notice" },
      ],
      tabCurrent: "c_news",
      list: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    tabChange(item) {
      this.breadcrumb[2].name = item.name;
      this.queryParams.pageNum = 1;
      this.getList();
    },
    getList() {
      const params = {
        ...this.queryParams,
        code: this.tabCurrent,
      };
      pageByCode(params).then((res) => {
        this.list = res.data && res.data.records;
        this.total = res.data && res.data.total;
      });
    },
    toDetail(id) {
      this.$router.push(`/newsDetail?id=${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.news-list {
  .item {
    background: #ffffff;
    display: flex;
    margin-bottom: 60px;
    .image {
      display: block;
      width: 313px;
      height: 186px;
      object-fit: cover;
      border-radius: 2px;
      transition: all 0.5s;
      &:hover {
        transform: scale(1.02);
      }
    }
    .item-content {
      flex: 1;
      padding: 12px 50px 5px;
      font-size: 14px;
      color: #333333;
      line-height: 1;
      cursor: pointer;
      &:hover {
        .name {
          text-decoration: underline;
          color: $main-color;
        }
      }
      .name {
        font-size: 18px;
        font-weight: bold;
        @include clamp(1);
      }
      .time {
        margin-top: 20px;
      }
      p {
        line-height: 2;
        margin-top: 30px;
        @include clamp(3);
      }
    }
    .btn {
      background: #eeedf0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 78px;
      height: 136px;
      border-radius: 2px;
      cursor: pointer;
      &:hover {
        em {
          text-decoration: underline;
        }
      }
      em {
        font-weight: bold;
        margin-bottom: 20px;
        font-size: 15px;
        color: $main-color;
      }
    }
  }
}
.isMobile {
  .news-list {
    .item {
      display: block;
      margin-bottom: 20px;
      border-bottom: 1px solid #eee;
      .image {
        width: 100%;
        height: 120px;
      }
      .item-content {
        padding: 12px;
      }
      .btn {
        width: 98px;
        height: 40px;
        margin: 0 auto;
        flex-direction: row;
        em {
          margin-bottom: 0;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
